import { Link } from "react-router-dom";
import { ArrowUpRight, Calendar, Clock } from "lucide-react";
import { BLOG_POSTS } from "@/lib/blog";
import useSEO from "@/hooks/useSEO";

const fmtDate = (iso) => new Date(iso).toLocaleDateString("en-CA", { year: "numeric", month: "long", day: "numeric" });

export default function Blog() {
  useSEO({
    title: "Blog · Signs, Wraps & Vinyl Insights for Toronto Businesses",
    description: "Practical case studies, comparisons, and how-tos on custom signs, architectural wraps, and window film for Toronto and GTA businesses.",
    path: "/blog",
  });

  return (
    <>
      <section className="pt-36 pb-16 bg-ink-950 border-b border-white/5" data-testid="blog-hero">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <div className="eyebrow gold-bar">Insights</div>
          <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Notes from the studio.</h1>
          <p className="text-white/60 max-w-2xl mt-5 text-lg">Case studies, comparisons, and honest answers about signs, wraps, and architectural vinyl for businesses across Toronto and the GTA.</p>
        </div>
      </section>

      <section className="py-20 bg-ink-950">
        <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {BLOG_POSTS.map(p => (
            <Link key={p.slug} to={`/blog/${p.slug}`} data-testid={`post-card-${p.slug}`} className="card-dark group overflow-hidden flex flex-col">
              <div className="aspect-[5/3] overflow-hidden">
                <img src={p.image} alt={`${p.title} — Toronto Custom Signs & Wraps blog`} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"/>
              </div>
              <div className="p-7 flex flex-col flex-1">
                <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.22em] text-white/45">
                  <span className="flex items-center gap-1.5"><Calendar size={11}/> {fmtDate(p.date)}</span>
                  <span className="text-white/20">·</span>
                  <span className="flex items-center gap-1.5"><Clock size={11}/> {p.readMinutes} min</span>
                </div>
                <h2 className="font-display text-2xl mt-4 text-white group-hover:text-gold transition-colors leading-tight">{p.title}</h2>
                <p className="text-white/55 text-sm mt-4 leading-relaxed flex-1">{p.excerpt}</p>
                <div className="mt-6 flex items-center gap-2 text-[12px] uppercase tracking-[0.2em] text-gold">
                  Read article <ArrowUpRight size={14}/>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
